import React from 'react';

import Comment from './Comment.jsx';
import CommentFormWithAvatar from './CommentFormWithAvatar.jsx';
import SideDropdown from './SideDropdown.jsx';
import Divider from './Divider.jsx';
import Number from './Number.jsx';

import './CommentBox.css';

function hasValidChildren(comment) {

    if (!comment.replies || comment.replies.length === 0) {

        return !!comment.body;
    }

    return !!(comment.replies || []).find(hasValidChildren);
}

class CommentBox extends React.Component {

    static defaultProps = {
        sortOrderOptions: [
            'best',
            'newest',
            'oldest'
        ],
    };

    state = {
        sortOrder: this.props.sortOrder || 'best',
        changingStatus: false
    };

    onChangeSortOrder = sortOrder => {

        this.setState({ sortOrder });
    };

    renderComments = (comments = [], isMain = false) => {

        const { page } = this.props;

        if (page.status === 'disabled') {
            return null;
        }

        const lis = (isMain ? comments.filter(c => !c.parentCommentId) : comments)
            .filter(hasValidChildren)
            .sort((a, b) => {

                if (a.isNew && b.isNew) {
                   return parseInt(b.createdAt) - parseInt(a.createdAt);
                } else if (a.isNew) {
                    return -1;
                } else if (b.isNew) {
                    return 1;
                }
                let aScore = 0;
                let bScore = 0;

                switch(this.state.sortOrder) {
                    case 'best':
                        aScore = page.pinnedComments[a.id] ? Infinity : a.rank;
                        bScore = page.pinnedComments[b.id] ? Infinity : b.rank;

                        if (aScore === Infinity && bScore === Infinity) {
                            aScore = parseInt(a.createdAt);
                            bScore = parseInt(b.createdAt);
                        }

                        break;
                    case 'newest':
                        aScore = page.pinnedComments[a.id] ? Infinity : parseInt(a.createdAt);
                        bScore = page.pinnedComments[b.id] ? Infinity : parseInt(b.createdAt);

                        if (aScore === Infinity && bScore === Infinity) {
                            aScore = parseInt(a.createdAt);
                            bScore = parseInt(b.createdAt);
                        }

                        break;
                    case 'oldest':
                        aScore = page.pinnedComments[b.id] ? -Infinity : parseInt(b.createdAt);
                        bScore = page.pinnedComments[a.id] ? -Infinity : parseInt(a.createdAt);

                        if (aScore === -Infinity && bScore === -Infinity) {
                            aScore = parseInt(b.createdAt);
                            bScore = parseInt(a.createdAt);
                        }
                        break;
                }

                if (aScore < bScore) {
                    return 1;
                }
                if (aScore > bScore) {
                    return -1;
                }

                return 0;
            })
            .map(comment => {

                return (
                    <li key={`comment/${comment.id}`}>
                        <Comment
                            {...this.props}
                            comment={comment}
                            renderComments={this.renderComments}
                        />
                    </li>
                );
            });

        return (
            <ul className="comments">
                { lis }
            </ul>
        );
    };

    onClickUpdateStatus = ({ currentTarget: { value } }) => {

        this.setState({ changingStatus: true }, () => {

            this.props.updatePageStatus(value).then(() => this.setState({ changingStatus: false }));
        });
    };

    get moderationPlusSettings() {

        if (!(this.props.userIsModerator && this.props.isModerationPlus)) {
            return null;
        }

        return (
            <div className="moderation-plus-settings">
                <Divider />
                <button
                    type="button"
                    value={this.props.page.status === 'locked' ? '' : 'locked'}
                    onClick={this.onClickUpdateStatus}
                    disabled={this.state.changingStatus}
                >
                    <span className="icon-lock_outline" /> {this.props.page.status === 'locked' ? 'unlock' : 'lock'}
                </button>
                <Divider />
                <button
                    type="button"
                    value={this.props.page.status === 'disabled' ? '' : 'disabled'}
                    onClick={this.onClickUpdateStatus}
                    disabled={this.state.changingStatus}
                >
                    <span className="icon-power_settings_new" /> {this.props.page.status === 'disabled' ? 'enable' : 'disable'}
                </button>
            </div>
        );
    }

    render() {

        const {
            comments
        } = this.props;
        const replies = {};

        const commentsToRender = comments.map(_comment => {

            const comment = Object.assign({}, _comment);
            const pieces = comment.id.split('/'); pieces.pop();
            comment.parentCommentId = pieces.length === 0 ? null : pieces.join('/');
            comment.replies = replies[comment.id] || [];
            replies[comment.id] = comment.replies;

            if (comment.parentCommentId) {

                if (!replies[comment.parentCommentId]) {
                    replies[comment.parentCommentId] = [];
                }
                replies[comment.parentCommentId].push(comment);
            }

            return comment;
        });

        return (
            <div className="comment-box">

                <div className="header">
                    <div className="clearfix">
                        <div className="left">
                            <h2>Comments <Number value={comments.filter(comment => !!comment.body).length} /></h2>
                            {this.moderationPlusSettings}
                        </div>
                        <div className="right">

                            <div className="action-buttons">

                                <SideDropdown
                                    selected={this.state.sortOrder}
                                    options={this.props.sortOrderOptions}
                                    onChange={this.onChangeSortOrder}
                                />

                            </div>

                        </div>
                    </div>
                </div>

                <div className="body">
                    <CommentFormWithAvatar {...this.props} />
                    {this.renderComments(commentsToRender, true)}
                </div>

            </div>
        );
    }
}

export default CommentBox;



// WEBPACK FOOTER //
// ./src/components/CommentBox.jsx